import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

export default ({ columns, value, onChange }) => (
  <FormGroup className="mb-2">
    <Label htmlFor="sortColumn" className="mb-1">
      Column:
    </Label>
    <Input
      type="select"
      id="sortColumn"
      value={value}
      onChange={e => onChange(e.target.value)}
    >
      {columns.map(col => (
        <option key={col.key} value={col.key}>
          {col.name}
        </option>
      ))}
    </Input>
  </FormGroup>
);
